import {AuthRepository} from "./AuthRepository";
import {UserRepository} from "./UserRepository";
import {AxiosInstance} from "axios";
import {ObjectRepository} from "./ObjectRepository";
import {MeetingRepository} from "./MeetingRepository";
import {MessengerRepository} from "./MessengerRepository";
import {EventMembershipRepository} from "./EventMembershipRepository";
import {SessionRepository} from "./SessionRepository";
import {RatingRepository} from "./RatingRepository";
import {SchemaRepository} from "./SchemaRepository";
import {NotificationRepository} from "./NotificationRepository";
import {CommentRepository} from "./CommentRepository";
import {FileRepository} from "./FileRepository";
import {FavoriteRepository} from "./FavoriteRepository";
import {SettingRepository} from "./SettingRepository";
import {ConfigurationRepository} from "./ConfigurationRepository";
import {FormsRepository} from "./FormsRepository";
import {RealtimeRepository} from "./reatime-repository/RealtimeRepository";
import {PointRepository} from "./PointRepository";
import { StaticConfigRepository } from "./StaticConfigRepository";
import {WebConferenceRepository} from "@api/repositories/WebConferenceRepository";
import {AnalyticsRepository} from "@api/repositories/AnalyticsRepository";
import {WebConferencesSlidesRepository} from "@api/repositories/WebConferencesSlidesRepository";
import {TicketRepository} from "@api/repositories/TicketRepository";

export class RepositoryFabric {
    static AUTH = 'auth';
    static USER = 'user';
    static OBJECT = 'object';
    static MEETING = 'meeting';
    static MESSENGER = 'messenger';
    static EVENT_MEMBERSHIP = 'membership';
    static SESSION = 'session';
    static RATING = 'rating';
    static SCHEMA = 'schema';
    static NOTIFICATION = 'notification';
    static COMMENT = 'comment';
    static FILE = 'file';
    static FAVORITE = 'favorite';
    static SETTING = 'setting';
    static CONFIGURATION = 'configuration';
    static FORM = 'form';
    static REALTIME = 'realtime';
    static POINT = 'point';
    static STATIC = 'static';
    static WEB_CONFERENCE = 'webConference';
    static ANALYTICS = 'analytics';
    static WEB_CONFERENCE_SLIDES = 'webConferenceSlides';
    static TICKET = 'ticket';

    client: AxiosInstance;
    private map: { [key: string]: any } = {
        [RepositoryFabric.AUTH]: AuthRepository,
        [RepositoryFabric.USER]: UserRepository,
        [RepositoryFabric.OBJECT]: ObjectRepository,
        [RepositoryFabric.MEETING]: MeetingRepository,
        [RepositoryFabric.MESSENGER]: MessengerRepository,
        [RepositoryFabric.EVENT_MEMBERSHIP]: EventMembershipRepository,
        [RepositoryFabric.SESSION]: SessionRepository,
        [RepositoryFabric.RATING]: RatingRepository,
        [RepositoryFabric.SCHEMA]: SchemaRepository,
        [RepositoryFabric.NOTIFICATION]: NotificationRepository,
        [RepositoryFabric.COMMENT]: CommentRepository,
        [RepositoryFabric.FILE]: FileRepository,
        [RepositoryFabric.FAVORITE]: FavoriteRepository,
        [RepositoryFabric.SETTING]: SettingRepository,
        [RepositoryFabric.CONFIGURATION]: ConfigurationRepository,
        [RepositoryFabric.FORM]: FormsRepository,
        [RepositoryFabric.REALTIME]: RealtimeRepository,
        [RepositoryFabric.POINT]: PointRepository,
        [RepositoryFabric.STATIC]: StaticConfigRepository,
        [RepositoryFabric.WEB_CONFERENCE]: WebConferenceRepository,
        [RepositoryFabric.ANALYTICS]: AnalyticsRepository,
        [RepositoryFabric.WEB_CONFERENCE_SLIDES]: WebConferencesSlidesRepository,
        [RepositoryFabric.TICKET]: TicketRepository
    };

    private repositories: { [key: string]: object } = {};

    constructor(client: AxiosInstance) {
        this.client = client;
    }

    get<T>(name: string): T {
        if (this.repositories[name]) {
            return this.repositories[name] as unknown as T;
        }
        if (name === RepositoryFabric.REALTIME || name === RepositoryFabric.STATIC) {
            this.repositories[name] = new this.map[name](this.client);
            return this.repositories[name] as unknown as T;
        }
        return new this.map[name](this.client) as T;
    }
}
